export default (url: string) => {
  let encodedStr = "";
  const encodeChars = ["(", ")"];
  url = encodeURI(url);

  for (let i = 0, len = url.length; i < len; i++) {
    if (encodeChars.indexOf(url[i]) >= 0) {
      const hex = url.charCodeAt(i).toString(16);
      encodedStr += "%" + hex;
    } else {
      encodedStr += url[i];
    }
  }
  return encodedStr.replace(" ", "%20");
};
